export const higherEdQueryKeys = {
  org: (orgId: string) => [ 'higherEdOrg', orgId ],
  orgs: () => [ 'higherEdOrgs', 'all' ],
  manager: (managerId: string) => [ 'higherEdManager', managerId ],
  managerByToken: () => [ 'orgManagerByToken' ],
  managerCredentials: (managerId: string) => [ 'higherEdManager', managerId, 'credentials' ],
  managers: (orgId: string) => [ 'higherEdManagers', orgId ],
  students: (orgId: string) => [ 'students', orgId ],
  student: (studentId: string) => [ 'student', studentId ],
  studentReferral: (studentId: string) => [ 'studentReferral', studentId ],
  bulkStudentReferrals: () => [ 'bulkStudentReferrals', 'all' ],
  dashboard: (orgId: string) => [ 'dashboard', orgId ],
  studentContacts: (studentId: string) => [ 'student', 'contacts', studentId ],
  higherEdUserProfile: (userId: string) => [ 'higherEdUser', 'profile', userId ],
  nonPartnerInsuranceCompanies: (stateId: string) => [ 'nonPartnerInsuranceCompanies', stateId ],
  nonPartnerInsuranceCompany: (companyId: string) => [ 'nonPartnerInsuranceCompany', companyId ],
  nonPartnerInsuranceByStudentId: (studentId: string, includeArchived: boolean) => [ 'nonPartnerInsuranceByStudentId', studentId, includeArchived ],
};
